import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Step1Component } from './step1/step1.component';
import { Step2Component } from './step2/step2.component';
import { Step3Component } from './step3/step3.component';
import { TipiVisiteComponent } from './tipi-visite-components/tipi-visite/tipi-visite.component';
import { ViniVendibiliComponent } from './vini-components/vini-vendibili/vini-vendibili.component';
import { CollegateComponent } from './collegate/collegate.component';
import { RecensioniComponent } from './recensioni_cantina/recensioni/recensioni.component';
import { Step1RegaloComponent } from './step1-regalo/step1-regalo.component';
import { FaqComponent } from './recensioni_cantina/faq/faq.component';
import { Step1VinoComponent } from './step1-vino/step1-vino.component';
import { SezioniTipiVisiteComponent } from './tipi-visite-components/sezioni-tipi-visite/sezioni-tipi-visite.component';


const routes: Routes = [

  { path: 'tv/:cantina/:lingua/:layout/:cart/:idCookie', component: TipiVisiteComponent },
  { path: 'se/:cantina/:lingua/:sezione/:layout/:cart/:idCookie', component: SezioniTipiVisiteComponent },
  { path: 'co/:cantina/:lingua/:layout/:cart/:idCookie/:idSezione', component: CollegateComponent },
  { path: 're/:cantina', component: RecensioniComponent },
  { path: 'faq/:cantina/:lingua', component: FaqComponent },
  { path: 'vi/:cantina/:lingua/:layout/:cart/:idCookie', component: ViniVendibiliComponent },
  { path: 'regalo/:cantina/:visita/:lingua/:idCookie', component: Step1RegaloComponent, data: { animation: 'Step1' } },
  { path: 'vino/:cantina/:vino/:lingua/:idCookie', component: Step1VinoComponent, data: { animation: 'Step1' } },
  { path: ':cantina/:visita/:lingua/:idCookie', component: Step1Component, data: { animation: 'Step1' } },
  { path: 'step2/:idCookie/:lingua', component: Step2Component, data: { animation: 'Step2' } },
  { path: 'step3/:risultato', component: Step3Component, data: { animation: 'Step2' } },
];



@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledBlocking',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
